export const executePlaybook = `
    mutation executePlaybook($input: ExecutePlaybookInput!) {
        executePlaybook(input: $input) {
            id
            playbookId
            name
            executionStatus
            sfnExecutionArn
            startedAt
            createdByUsername
            created
            updated
        }
    }
`;

export const cancelExecution = `
    mutation cancelExecution($input: CancelExecutionInput!) {
        cancelExecution(input: $input) {
            id
            executionStatus
            completedAt
            failureReason
            updated
        }
    }
`;
